import React, { SVGProps } from 'react';

const SvgVideo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 66 66"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path
      fill="#A2A9AD"
      d="M12.467 17.6H7.333v35.933c0 2.824 2.31 5.134 5.134 5.134H48.4v-5.134H12.467V17.6ZM53.533 7.333h-30.8c-2.823 0-5.133 2.31-5.133 5.134v30.8c0 2.823 2.31 5.133 5.133 5.133h30.8c2.824 0 5.134-2.31 5.134-5.133v-30.8c0-2.824-2.31-5.134-5.134-5.134ZM33 39.417v-23.1l15.4 11.55L33 39.417Z"
    />
  </svg>
);

export default SvgVideo;
